import React, { Component } from "react";
import FormGroupContainer from "../FormGroup/FormGroupContainer";
import { injectIntl } from "react-intl";
import Wrapper from "../FormGroup/Wrapper";
import Label from "assets/scripts/components/common/form/FormGroup/Label";
import HelpBlock from "assets/scripts/components/common/form/FormGroup/HelpBlock";
import Message from "assets/scripts/components/common/Message/Message";
import ErrorBlock from "../FormGroup/ErrorBlock";
import cn from "classnames";
function getLabelId(baseId) {
    return `${baseId}-label`;
}
class Radio extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleChange = this._handleChange.bind(this);
    }
    render() {
        const { props } = this;
        const { option, suppressAria } = props;
        const id = `${props.baseId}-option${props.index}`;
        return (<div className={cn("radio", { vertical: !!props.vertical })}>
				<input {...props.attrs} id={id} name={props.baseId} type="radio" value={option.value} checked={option.value === props.value} className="radio-function" onChange={this._handleChange} aria-labelledby={!suppressAria ? getLabelId(props.baseId) : undefined}/>
				<label htmlFor={id} className="radio-style">
					<span className="radio-style-box"/>
					<span className="radio-style-label">
						<Message value={option.label}/>
					</span>
				</label>
			</div>);
    }
    _handleChange(event) {
        this.props.onChange(event.currentTarget.value, event);
    }
}
class RadioFormGroup extends Component {
    render() {
        const { props } = this;
        const { intl, groupLabel, options, vertical, suppressAria, ...otherProps } = props;
        const ariaLabel = groupLabel == null ? undefined
            : typeof groupLabel === "string" ? groupLabel
                : intl.formatMessage(groupLabel, groupLabel.values);
        return (<FormGroupContainer {...otherProps}>
				{({ error, id, helpId, errorId, controlState }) => (<Wrapper className={props.className} showError={error != null} role={!suppressAria ? "group" : undefined} aria-label={ariaLabel}>
						<div id={getLabelId(id)} className="label">
							<Label label={props.label} required={props.required}/>
							{props.help != null && (<HelpBlock id={helpId} help={props.help}/>)}
							{props.error != null && (<ErrorBlock id={errorId} error={error}/>)}
						</div>
						{options.map((option, index) => (<Radio key={index} {...controlState} baseId={id} index={index} option={option} error={error} intl={intl} vertical={vertical} suppressAria={suppressAria}/>))}
					</Wrapper>)}
			</FormGroupContainer>);
    }
}
export default injectIntl(RadioFormGroup);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/RadioFormGroup/RadioFormGroup.tsx